/* ErroredView.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./ErroredView.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import ErrorIcon from '@atlaskit/icon/core/migration/status-error--error';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { R300 } from '@atlaskit/theme/colors';
import { messages } from '../../../messages';
import { Frame } from '../components/ErrorFrame';
var styles = {
  boxStyles: "_19bv1b66 _u5f31b66"
};
export var EmbedCardErroredView = function EmbedCardErroredView(_ref) {
  var onRetry = _ref.onRetry,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'embed-card-errored-view' : _ref$testId,
    inheritDimensions = _ref.inheritDimensions;
  return /*#__PURE__*/React.createElement(Frame, {
    inheritDimensions: inheritDimensions,
    compact: true,
    isSelected: isSelected,
    testId: testId
  }, /*#__PURE__*/React.createElement(ErrorIcon, {
    LEGACY_size: "small",
    color: "var(--ds-icon-danger, ".concat(R300, ")"),
    label: "error-icon"
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.boxStyles
  }, /*#__PURE__*/React.createElement(Inline, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.could_not_load_link))), /*#__PURE__*/React.createElement(Button, {
    testId: "err-view-retry",
    spacing: "compact",
    onClick: onRetry
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.try_again)));
};